import {
  DialogDescription,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogClose,
  DialogTitle,
  Checkbox,
  Button,
  Dialog,
  Label,
} from '@ui/components';
import { UserTableDto } from '@interfaces/models';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';

export const RemoveUserDialog = ({
  isLoading,
  isOpen,
  user,
  onRemoveUser,
  onClose,
}: {
  onRemoveUser: () => void;
  onClose: () => void;
  isLoading: boolean;
  user: UserTableDto;
  isOpen: boolean;
}) => {
  const { t } = useTranslation();
  const [isChecked, setIsChecked] = useState(false);

  const userName = `${user.firstName} ${user.lastName} (${user.email})`;

  return (
    <Dialog onOpenChange={onClose} open={isOpen}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t('USERS.REMOVE_USER_DIALOG_TITLE')}</DialogTitle>
        </DialogHeader>
        <DialogDescription>{t('USERS.REMOVE_USER_DIALOG_DESCRIPTION')}</DialogDescription>
        <div className="px-4 flex items-center gap-2">
          <Checkbox
            onCheckedChange={(checked) => setIsChecked(!!checked)}
            id="remove-user-checkbox"
            checked={isChecked}
          />
          <Label htmlFor="remove-user-checkbox">
            {t('USERS.REMOVE_USER_CHECKBOX_DESCRIPTION', { name: userName })}
          </Label>
        </div>
        <DialogFooter>
          <DialogClose asChild>
            <Button disabled={isLoading} variant="tertiary" size="large" wide>
              {t('USERS.REMOVE_USER_DIALOG_CANCEL')}
            </Button>
          </DialogClose>
          <Button
            disabled={isLoading || !isChecked}
            onClick={onRemoveUser}
            isLoading={isLoading}
            size="large"
            wide
          >
            {t('USERS.REMOVE_USER_DIALOG_DELETE')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
